"use strict";
/** @jsxRuntime classic */
/** @jsx jsx */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.JagexSocials = exports.YOUTUBE_ALT_TEXT = exports.TWITTER_ALT_TEXT = exports.FACEBOOK_ALT_TEXT = exports.YOUTUBE_LINK = exports.TWITTER_LINK = exports.FACEBOOK_LINK = void 0;
var theme_ui_1 = require("theme-ui");
var facebook_svg_1 = __importDefault(require("../../styles/Icons/assets/facebook.svg"));
var twitter_svg_1 = __importDefault(require("../../styles/Icons/assets/twitter.svg"));
var youtube_svg_1 = __importDefault(require("../../styles/Icons/assets/youtube.svg"));
exports.FACEBOOK_LINK = "https://www.facebook.com/Jagex";
exports.TWITTER_LINK = "https://twitter.com/Jagex";
exports.YOUTUBE_LINK = "https://www.youtube.com/channel/UCTTjUNeLx32fv9DZCBZ3Dig";
exports.FACEBOOK_ALT_TEXT = "Facebook platform F icon";
exports.TWITTER_ALT_TEXT = "Twitter platform bird icon";
exports.YOUTUBE_ALT_TEXT = "YouTube platform Play icon";
var JagexSocials = function () { return (theme_ui_1.jsx(theme_ui_1.Box, { sx: {
        mt: 2,
        "> a": {
            mr: 3
        }
    } },
    theme_ui_1.jsx(theme_ui_1.Link, { href: exports.FACEBOOK_LINK, target: "_blank", rel: "nofollow" },
        theme_ui_1.jsx("img", { src: facebook_svg_1.default, alt: exports.FACEBOOK_ALT_TEXT })),
    theme_ui_1.jsx(theme_ui_1.Link, { href: exports.TWITTER_LINK, target: "_blank", rel: "nofollow" },
        theme_ui_1.jsx("img", { src: twitter_svg_1.default, alt: exports.TWITTER_ALT_TEXT })),
    theme_ui_1.jsx(theme_ui_1.Link, { href: exports.YOUTUBE_LINK, target: "_blank", rel: "nofollow" },
        theme_ui_1.jsx("img", { src: youtube_svg_1.default, alt: exports.YOUTUBE_ALT_TEXT })))); };
exports.JagexSocials = JagexSocials;
